module.exports = __webpack_public_path__ + "static/logo-white-cd37749d7f2b8d889bb699e175eb0ed2.png";